module.exports = __webpack_public_path__ + "static/media/logo_sin_texto.5c8cefc1.png";